<template>
    <div>
        <add-address></add-address>
    </div>
</template>

<script>
import AddAddress from "@/components/modal/AddAddress.vue";
export default {
    components: {
        AddAddress,
    },
};
</script>
